import { Dialog, DialogContent } from "@/components/ui/dialog"
import { useCompositorStore } from "@/lib/stores/compositor-store"
import { CompositorLayersSidebar } from "./CompositorLayersSidebar"
import { CompositorInspector } from "./CompositorInspector"
import { CompositorToolbar } from "./CompositorToolbar"
import { CompositorCanvas } from "./CompositorCanvas"

export function CompositorEditor() {
  const isOpen = useCompositorStore((s) => s.isOpen)
  const config = useCompositorStore((s) => s.config)
  const prepareClose = useCompositorStore((s) => s.prepareClose)

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) prepareClose() }}>
      <DialogContent className="sm:max-w-[95vw] w-[95vw] h-[90vh] p-0 gap-0 flex flex-col overflow-hidden">
        {/* Top bar */}
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-border/50 bg-background shrink-0">
          <span className="text-[13px] font-medium">
            Compositor
            {config && (
              <span className="ml-2 text-[11px] text-muted-foreground font-normal">
                {config.canvas.width}×{config.canvas.height} · {config.canvas.duration}s
              </span>
            )}
          </span>
        </div>

        {/* Three-panel main area */}
        <div className="flex flex-1 overflow-hidden">
          {/* Left: Layers sidebar */}
          <div className="w-[200px] shrink-0 border-r border-border/50 overflow-hidden">
            <CompositorLayersSidebar />
          </div>

          {/* Center: Konva canvas */}
          <div className="flex-1 overflow-hidden bg-neutral-200 dark:bg-neutral-900">
            <CompositorCanvas />
          </div>

          {/* Right: Inspector */}
          <div className="w-[220px] shrink-0 border-l border-border/50 overflow-hidden">
            <CompositorInspector />
          </div>
        </div>

        {/* Bottom toolbar */}
        <div className="shrink-0">
          <CompositorToolbar />
        </div>
      </DialogContent>
    </Dialog>
  )
}
